<template>
    <div class="help">
        <div class="menu">
            <ul>
                <li @click="status=true;">常见报错处理</li>
                <li @click="status=true;">高级VIP插件教程</li>
            </ul>
        </div>
        <div class="list_content">
            <div class="list" v-if="status">
                <h3>常见报错处理</h3>
                <ul>
                    <li v-for="(item,index) in all_content" :key="index" @click="look(index)">
                        {{item.title}}
                    </li>
                </ul>
            </div>
            <div class="content" v-else>
                <h3 class="h3">
                    <span @click="status=!status;article=null" class="back_btn">
                        <i class="el-icon-caret-left"></i>
                        返回
                    </span>&nbsp;|
                    资源列表中找不到想要的数据库
                </h3>
                <p v-for="(paragraph,i) in article" :key="i" class="paragraph">{{paragraph}}</p>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                status: true,
                article: null,
                all_content:[
                    {
                        title: '资源列表中找不到想要的数据库',
                        content: [
                            '由于本馆可以访问的数据库种类很多，达上千种，因此只列出了大家常用的一些数据库在资源列表上。如果您在资源列表页面上找不到自己想要的数据库，请到大学图书馆入口中，找如下链接查找您要的数据库：',
                            '★数据库长列表(List)   -----列表很长，可以按Ctrl+F寻找',
                            '数据库查询(按字母)      -----这个按字母寻找即可',
                            '如果还找不到，请于馆长联系，我们会给您解决。'
                        ]
                    },
                    {
                        title: '怎么有些文章点击下载还需要收费呢',
                        content: [
                            '本馆已经集合了全世界最顶级的文献数据库权限，但是这些世界名校购买的资源并非都是100%的。不过各大学之间是互补的，偶尔遇到还需要收费的文章，请尝试更换大学的入口，一般可以解决。',
                            '如果换了几个大学还遇到收费，请将文献信息发到我们的专用客服信箱 mylibs@163.com ，我们将及时为您解决。',
                        ]
                    },
                    {
                        title: '浏览器提示不受信任的网页或证书',
                        content: [
                            '因为部分数据库采用了ssl安全加密传输，会导致部分浏览器提示不受信任的网页或证书。一般只需要点继续访问或者对该网页添加信任即可',
                            '页面都是安全的，请放心使用。',
                        ]
                    },
                    {
                        title: '中国知网CNKI下载提示超量或无权限',
                        content: [
                            '如果中国知网CNKI下载提示超量或无权限或者要登录，可以尝试更换一下其他入口，也可以到中国大学图书馆里面选取一个大学进入找他的CNKI进行访问。',
                            '如果反复尝试还有问题，请速联系馆长。',
                        ]
                    },
                ]
            }
        },
        methods: {
            look (index) {
                this.status = !this.status;
                this.article = this.all_content[index].content
            }
        }
    }
</script>
<style scoped>
    .help {
        width: 1030px;
        margin: 0 auto;
        display: flex;
    }
    .menu {
        width: 240px;
        margin: 20px;
        border-top: 1px solid #ccc;
    }
    .menu li {
        font-size: 14px;
        padding: 10px 20px;
        border-bottom: 1px solid #ccc;
        cursor: pointer;
    }
    .menu li:hover {
        background-color: #eee;
        color: #6BA2C0;
    }
    .list_content {
        flex: 1;
        margin-top: 20px;
    }
    .list h3,.h3 {
        font-size: 16px;
        color: #b60005;
        font-weight: 600;
        padding-top: 20px;
        padding-bottom: 10px;
    }
    .list li {
        color: #069;
        font-size: 14px;
        padding: 5px 0;
        cursor: pointer;
    }
    .list li:hover {
        color: #6BA2C0;
        text-decoration: underline;
    }
    .back_btn {
        color: #666;
        cursor: pointer;
    }
    .back_btn:hover {
        color: #000;
    }
    .paragraph {
        font-size: 16px;
        color: #333;
        text-indent: 1em;
        margin-bottom: 20px;
    }
</style>